<template>
<div class="Report">
    <keep-alive include='reportList'>
        <router-view></router-view>        
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'Report',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Report {
}
</style>
